import { render, staticRenderFns } from "./PressSection.vue?vue&type=template&id=2d1e60a9&"
import script from "./PressSection.vue?vue&type=script&lang=js&"
export * from "./PressSection.vue?vue&type=script&lang=js&"
import style0 from "./PressSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports